import { ReactNode } from 'react';

import { useIntl } from 'react-intl';

import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { Login } from '@/components/signup/account-creation/components/login/login';
import { JSMOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { useIsJsmCrossflow } from '@/components/signup/layouts/use-is-jsm-crossflow.ts';
import { getLoginUrl } from '@/components/signup/utils/url';
import { Link } from '@/libraries/design/components/link/src/link';

import { JSMGetStartedText, JSMCrossflowGetStartedText } from '../components/get-started-heading';
import { Headings } from '../components/headings';
import { YourPlanIncludesText } from '../components/sub-heading';
import { InputSubmitButton } from '../components/submit-input';

const LoggedOutContent = () => {
	const intl = useIntl();
	const isJsmCrossflow = useIsJsmCrossflow();
	const headingMain = isJsmCrossflow ? <JSMCrossflowGetStartedText /> : <JSMGetStartedText />;

	const atlassianAccountLoginText = intl.formatMessage(
		{
			id: 'BxpUiSignup.SignupForm.existingAtlassianAccount',
			defaultMessage: 'Already have an Atlassian account? <logInLink>Log in</logInLink>',
		},
		{
			logInLink: (text: ReactNode) => logInLink(text, location),
		},
	);

	return (
		<>
			<Headings main={headingMain} sub={<YourPlanIncludesText />} />
			<AccountCreation
				Input={<InputSubmitButton />}
				Submit={null}
				Login={<Login loginText={atlassianAccountLoginText} />}
				identityCobranding={
					isJsmCrossflow
						? 'wac--service-collection-jsm-cobranding'
						: 'wac--service-collection-cobranding'
				}
			/>
		</>
	);
};

export const LoggedOut = () => (
	<JSMOverlayTemplate size="sm">
		<LoggedOutContent />
	</JSMOverlayTemplate>
);

const logInLink = (text: ReactNode, location: Location) => (
	<Link
		text={text as unknown as string}
		aria-label={text as unknown as string}
		type="inline"
		href={getLoginUrl(location)}
	/>
);
